module.exports = __webpack_public_path__ + "assets/cheerup4.ac072495.svg";